import SystemLevelAKnowledgeDefinition from "../SystemLevelAKnowledgeDefinition";
import {isNullOrUndefined} from "../../../services/Validator";
import DetailedCourseLevelAKnowledgeExample from "./DetailedCourseLevelAKnowledgeExample";

export default function DetailedCourseScreenContent({levelA}) {
    // Used in SingleKnowledgeScreen to display Knowledge
    // related content

    // BUILD
    if (isNullOrUndefined(levelA))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 grow flex flex-col justify-start px-[16px] py-[20px]"}>
            <SystemLevelAKnowledgeDefinition knowledge={levelA?.levelAKnowledge} />
            <DetailedCourseLevelAKnowledgeExample knowledge={levelA?.levelAKnowledge} />
        </div>
    );
}